const COMMON = {
  USER_PROFILE: 'User Profile',

  // profile drop down
  PACK_TYPE: 'Package Type',
  REMAINING_CONVS: 'Remaining Conversations',
  REMAINING_DAYS: 'Remaining Days',
  UPGRADE_PACKAGE: 'Upgrade',
  CHARGE_CONVS: 'Conversation Charge',
  BILLS_LIST: 'Bills',
  PROFILE: '',
  COMPLETE_INFO: 'Complete Info',
  EXIT: 'Exit',
  UNLIMITED_CONVS_TITLE: 'Unlimited',
  DAYS_SUFFIX: 'Days',

  MOBILE_FIELD_PLACEHOLDER: 'Mobile- +989*********',
  EMAIL_PLACEHOLDER: 'Email',

  TODAY: 'Today',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',

  MONTH_1: 'January',
  MONTH_2: 'February',
  MONTH_3: 'March',
  MONTH_4: 'April',
  MONTH_5: 'May',
  MONTH_6: 'June',
  MONTH_7: 'July',
  MONTH_8: 'August',
  MONTH_9: 'September',
  MONTH_10: 'October',
  MONTH_11: 'November',
  MONTH_12: 'December',

  MODAL: {
    PROFILE_TITLE: '',
    PROFILE_AVATAR_HINT: '',
    PROFILE_AVATAR_UPLOAD: '',
    PROFILE_FORM_FULL_NAME: '',
    PROFILE_FORM_TITLE: '',
    PROFILE_FORM_PHONE: '',
    PROFILE_FORM_EMAIL: '',
    PROFILE_FORM_PASSWORD: '',
    PROFILE_FORM_PASSWORD_CONFIRM: '',
    PROFILE_OPERATORS_LIST_TITLE: '',
    PROFILE_FORM_CONFIRM: '',

    CANCEL: '',
  },

  INFO_LAW_TAB: 'Legal',
  INFO_PERSON_TAB: 'Person',

  INFO_LAW_NAME: 'Company Name',
  INFO_LAW_NATIONAL_CODE: 'Passport ID',
  INFO_LAW_ECONOMIC: 'Economic Code',
  INFO_LAW_REGISTER: 'Register Number',
  INFO_LAW_PHONE: 'Phone number(with area code)',
  INFO_LAW_POST: 'zip code',
  INFO_LAW_ADDRESS: 'Address',

  INFO_PERSON_NAME: 'Name',
  INFO_PERSON_LAST_NAME: 'Last Name',
  INFO_PERSON_NATIONAL: 'Passport ID',
  INFO_PERSON_PHONE: 'Phone',
  INFO_PERSON_POST: 'zip code',
  INFO_PERSON_ADDRESS: 'Address',

  USER_INFO_ADDRESS_PLACEHOLDER_DEFAULT: 'Address (factor will be sent here)',
  USER_INFO_MOBILE_VERIFY_SUBMIT: 'Save changes',

  WEBSITE_SELECT_TITLE: 'Select Website',

  FREE_PACKAGE_OVERLAY:
    'This section is not included in Free package, please upgrade your package',
  SUBMIT_MODAL_BTN: 'Submit',
  CANCEL_MODAL_BTN: 'Cancel',

  // Date picker
  YESTERDAY: 'Yesterday',
  PAST_SEVEN_DAYS: 'Seven days',
  PAST_14_DAYS: 'Fourteen days',
  PAST_ONE_YEAR: 'One year',
  DATE_PICKER_SUBMIT: 'Submit',

  TIME_PICKER_AM_LABEL: 'AM',
  TIME_PICKER_PM_LABEL: 'PM',

  CANCEL_BTN_DEFAULT: 'Cancel',
  SUBMIT_BTN_DEFAULT: 'Submit',
  REMOVE_BTN_DEFAULT: 'Delete',
  SAVE_BTN_DEFAULT: 'Save',

  // selectbox
  SELECT_BOX_TITLE: 'Select',
  SELECT_BOX_EMPTY: 'List is empty',

  // verification card
  VERIFY_CARD: {
    TITLE: 'Verification Code',
    TRY_AGAIN: 'Try Again',
    NOT_RECIEVED: 'Not recieved code yet?',
  },

  // verification form
  VERIFICATION_FORM: {
    CODE_PLACEHOLDER: 'Enter code',
    SUBMIT_BTN: 'Check and continue',
    CANCEL_BTN: 'Return',
  },

  // verification modal
  MOBILE_VERIFICATION_MODAL: {
    TITLE: 'Mobile number confirm',
    CODE_PLACEHOLDER: 'Enter code',
    NOT_RECIEVED: 'Not recieved code yet?',
    TRY_AGAIN: 'Try again',
  },

  WIDGET_GENERATION_CARD: {
    TITLE: 'Website information',
    DESCRIPTION:
      'Enter title and address of the website that you want to install widget in',
  },

  DOCUMENT_PAGE_TITLE: 'Dashboard | Raychat',

  NEW_FEAT_BADGE: 'New',

  // packages
  PREMIUM_PACKAGE: 'Premium',
  commercial_PACKAGE: 'Commercial',
  BASE_PACKAGE: 'Base',

  // QUOTES
  QUOTE_1: {
    NAME: 'Adel Talebi',
    TEXT: 'I have used many online chats, such as Zopim, Crisp, JioChat, etc., three points in Raychat are of vital importance to us. Ease of use, Rial payment, and high-quality support.',
  },

  QUOTE_2: {
    NAME: 'Hamidreza Ahmadi',
    TEXT: ' I am very happy that Raychat was able to provide us with a useful and cost-effective service that can ease Telegram support and related problems.',
  },

  POPUP_MESSAGE: {
    CLOSE_DEFAULT: 'Ok',
    NEVER_SHOW_DEFAULT: "don't show this message again",
  },

  ENTER_PAGE_ADDRESS_PLACEHOLDER: 'Enter page address',

  // MULTI SELECT BOX
  MULTI_SELECT_BOX_TITLE: ' Selected Items',
  MULTI_SELECT_BOX_EMPTY_LIST: 'No items available!',

  BTN_DISABLED_PURCHASE_LINK_TITLE: 'Purchase',

  BROWSER_NOT_SUPPORTING_VIDEO_FILE: 'Your browser does not support video ',
  NEW_UPDATES_BRO: 'New Updates :)',

  // signup
  ENTERED_CODE_WRONG_TRY_AGAIN: 'Entered code is wrong, try again',

  USER_INFO_MODAL: {
    SUBMIT_BTN: 'Submit',
    CHECK_BTN: 'Check',
  },
};

export default COMMON;
